import { render, staticRenderFns } from "./TicketNewRoute.vue?vue&type=template&id=6d009f17"
import script from "./TicketNewRoute.vue?vue&type=script&lang=js"
export * from "./TicketNewRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports